export default __webpack_public_path__ + "static/media/books2-afterB-1440w.62c3827c.avif";